export default [
  {
    key: 'name',
    label: '客先名',
    style: {
    }
  }, 
  {
    key: 'code',
    label: '客先コード',
    style: {
    }
  },
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/customer/listHeader.js